// import WasmController from "react-lib/frameworks/WasmController";
import { ActionHandler, PickMainState } from "../common/CommonInterface";

// Sequence
import * as HealthRecommendation from "./sequence/HealthRecommendation";

export type State = 
  HealthRecommendation.State;

export type PickedState = PickMainState<
  | "buttonLoadCheck"
  | "errorMessage"
  | "successMessage"
  | "masterOptions"
  | "selectedEncounter"
  | "selectedEmr"
  | "selectedPatient"
  | "patientData"
>;

export type Props = {};

export type Event = 
  | HealthRecommendation.Event;

export type Data = 
  HealthRecommendation.Data;

export const StateInitial: State = {};

export const DataInitial = {
  ...HealthRecommendation.DataInitial,
};

type Handler<P = any, R = any> = ActionHandler<PickedState & State, Event, Data, P, R>;

// Func
export const PrintMedicalReportPHV: Handler = async (controller, params) => {
  await HealthRecommendation.HandlePrintMedicalReportPHV(controller, params);
};

export const GetCheckupReportListPHV: Handler = async (controller, params) => {
  return await HealthRecommendation.HandleGetCheckupReportListPHV(controller, params);
};